import superagent from 'superagent'
import { RequestCommonResponse } from '../actions'
import {
  UPDATE_LOADING,
  UPDATE_DIRECTION,
  UPDATE_BACK_PATH,
  UPDATE_PAGE_FROM,
  UPDATE_NEW_MESSAGE,
  UPDATE_WIN_HEIGHT,
  UPDATE_IS_TRIGGER_COLLECT,
  UPDATE_IS_TRIGGER_SEARCH,
  UPDATE_COMMON_CACHE_VAL,
  UPDATE_CHECK_LINE
} from '../mutation-types'

const baseUrl = 'https://wx.dudubashi.com' // 替换为基本URL

const state = {
  common_cache_val: {}, // 全局缓存变量
  is_trigger_collect: false, // 是否触发首页更新收藏列表
  is_trigger_search: false, // 是否触发更新搜索列表
  back_path: '', // 返回历史页面
  is_loading: false,
  direction: 'forward',
  page_from: '',
  win_height: window.innerHeight,
  need_jump_login: false,
  server_phone: '4008-520-084',
  is_wx: /micromessenger/.test(navigator.userAgent.toLowerCase()),
  is_android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
  is_mobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.userAgent.indexOf('Adr') > -1,
  new_message: false,
  check_search_line: {} // 缓存搜索选中的线路id
}

const mutations = {
  [UPDATE_COMMON_CACHE_VAL] (state, param) {
    if (param.name) {
      state.common_cache_val[param.name] = param.val || ''
    }
  },
  [UPDATE_LOADING] (state, is_loading) {
    state.is_loading = is_loading
  },
  [UPDATE_CHECK_LINE] (state, param) {
    state.check_search_line = param || {}
  },
  [UPDATE_IS_TRIGGER_COLLECT] (state, val) {
    state.is_trigger_collect = val
  },
  [UPDATE_IS_TRIGGER_SEARCH] (state, val) {
    state.is_trigger_search = val
  },
  [UPDATE_WIN_HEIGHT] (state, val) {
    state.win_height = val || window.innerHeight
  },
  [UPDATE_DIRECTION] (state, direction) {
    state.direction = direction
  },
  [UPDATE_BACK_PATH] (state, back_path) {
    state.back_path = back_path
  },
  [UPDATE_PAGE_FROM] (state, path) {
    state.page_from = path
  },
  [UPDATE_NEW_MESSAGE] (state, val) {
    state.new_message = val
  }
}

const actions = {
  setLoading ({ commit }, val) {
    commit('UPDATE_LOADING', val)
  },
  setCommonCacheVal ({ commit }, param) {
    commit('UPDATE_COMMON_CACHE_VAL', param)
  },
  setSearchCacheLine ({ commit }, param) {
    commit('UPDATE_CHECK_LINE', param)
  },
  setWinHeight ({ commit }, val) {
    commit('UPDATE_WIN_HEIGHT', val)
  },
  setCollectStatus ({ commit }, val) {
    commit('UPDATE_IS_TRIGGER_COLLECT', val)
  },
  setSearchStatus ({ commit }, val) {
    commit('UPDATE_IS_TRIGGER_SEARCH', val)
  },
  getMessage ({ commit, state, rootState }) {
    if (rootState.userInfo.user_id) {
      var params = {
        user_id: rootState.userInfo.user_id
      }
      if (rootState.config.enterprise_id) {
        params.enterprise_id = rootState.config.enterprise_id
      }
      superagent
      .post(baseUrl + '/index.php/users/message/message_notice')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              if (res.data.new_message !== 0) {
                commit('UPDATE_NEW_MESSAGE', true)
              } else {
                commit('UPDATE_NEW_MESSAGE', false)
              }
            },
            failCallback: function (res) {
            }
          })
        }
      })
    }
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js